import { useTranslation } from 'react-i18next';
import React from 'react';
import { formatDate } from 'helpers/dateHelper';
import EditIcon from '@mui/icons-material/Edit';
import { START_DATE } from 'routes/HumanResourcesModule/Simulation/SimulationSynthesis/helpers/constants';
import { RecurrenceEnum } from 'routes/HumanResourcesModule/Settings/HrPositionMapping/helpers/constants';
import { SimulationDateString } from 'routes/HumanResourcesModule/Simulation/helpers/types';
import StyChip from 'routes/HumanResourcesModule/components/ui/StyChip';
import {
    agentTypeValueFormatter,
    getAgentDepartureHypothesisDisplayType,
} from 'routes/HumanResourcesModule/Simulation/SimulationSynthesis/Agents/helpers/gridHelpers';
import {
    AgentDepartureHypothesis,
    DetailedAgentDepartureHypothesis,
} from './helpers/types';
import {
    AGENT_DEPARTURE_HYPOTHESIS_TYPE,
    AgentDepartureHypothesisType,
    AgentDepartureHypothesisTypesColor,
} from './helpers/constants';
// when the Chip is in update mode the type is AgentDepartureHypothesis
// else it is DetailedAgentDepartureHypothesis

const getDepartureHypothesisChipLabel = (
    agentDepartureHypothesisType: AgentDepartureHypothesisType,
    startDate: SimulationDateString,
    t: TranslationT,
    displayDate: boolean,
): string => {
    const hypothesisType = agentTypeValueFormatter(
        agentDepartureHypothesisType,
    );
    const hypothesisDate = formatDate(new Date(startDate));

    return displayDate
        ? t('humanResources.simulation.agentHypothesisChipLabel', {
              hypothesisType,
              hypothesisDate,
          })
        : hypothesisType;
};

type Props = {
    hypothesis: AgentDepartureHypothesis | DetailedAgentDepartureHypothesis;
    recurrence: RecurrenceEnum;
    isUpdateEnabled: boolean;
    displayDate?: boolean;
};

const AgentDepartureHypothesisChip = ({
    hypothesis,
    recurrence,
    isUpdateEnabled = true,
    displayDate = true,
}: Props): React.ReactElement => {
    const { t } = useTranslation();

    const displayType = getAgentDepartureHypothesisDisplayType(
        recurrence,
        hypothesis[AGENT_DEPARTURE_HYPOTHESIS_TYPE],
    );

    // In case the value is defined, we already have an hypothesis for this agent
    // we display it with the possibility to modify it

    const chipColor = AgentDepartureHypothesisTypesColor[displayType];
    const chipIcon = isUpdateEnabled ? <EditIcon /> : <></>;

    return (
        <>
            <StyChip
                label={getDepartureHypothesisChipLabel(
                    displayType,
                    hypothesis[START_DATE],
                    t,
                    displayDate,
                )}
                icon={chipIcon}
                styledColor={chipColor}
            />
        </>
    );
};

export default AgentDepartureHypothesisChip;
